import { render } from "./diService.vue?vue&type=template&id=40538012&lang=true"
import script from "./diService.vue?vue&type=script&lang=js"
export * from "./diService.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__